export default __webpack_public_path__ + "8e81169ec91d0b420dbb3f76e42843d3.png";